import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { KiProjekt } from '../models/ki-projekt.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class KiProjekteService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiBaseUrl}/api/v1/ki/projekte`;

  getProjekte(): Observable<KiProjekt[]> {
    return this.http.get<KiProjekt[]>(this.apiUrl);
  }

  setSperre(projectId: string, gesperrt: boolean): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${encodeURIComponent(projectId)}/sperre`, { gesperrt });
  }
}
